/*
 * Marionette ItemView: PaneParentView
 * -----------------------------
 * Parent view for both the EditorView and the LogView. Creates a title DIV
 * and a content DIV that appropriately  Parent view for both the EditorView
 * and the LogView. Creates a title DIV and a content DIV that appropriately
 * resize when the window resizes. We note that the following options must be
 * defined when a child is created:
 *   {
 *     uniqueID: [a unique ID for this view],
 *     title: [a user readable title for this view]
 *   }
 */
import $ from 'jquery';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import template from '@/../templates/ide-editor-template.hbs';

    var PaneParentView = Marionette.View.extend({

        /* Basic Properties */
        tagName: 'div',
        template: Handlebars.compile(template),

        /*
         * Function: initialize
         * --------------------
         * Renders on call and sets up resize listeners.
         */
        initialize: function(options) {
            this.options = options;
            // Keep track of resizes to resize the height
            $(window).on('resize', $.proxy(this._resize, this));
            $(window).on('layoutResize', $.proxy(this._resize, this));
        },
        serializeData : function() {
          return ({
            id : this.options.uniqueID,
            name : this.options.name
          });
        },

        /*
         * Function: _resize
         * -----------------
         * Internal function called on any resizes - resizes the content height.
         */
        _resize: function() {
            var parentHeight = this.$el.parent().outerHeight();
            var headerHeight = this.$el.children($('.title-pane')).outerHeight();

            // Set the height of the content
            this.$el.find($('#' + this.options.uniqueID)).css({
                'height': parentHeight - headerHeight
            });
        }
    });
    export default PaneParentView;

